module.exports = __webpack_public_path__ + "images/1e72e80943271b956f996d52bc7f50bb.svg";